import { Injectable } from '@angular/core';
import { CoreTypes } from 'common-cloudstudio';
import { GearTypes } from 'common-gear';
import { BehaviorSubject } from 'rxjs';
import { CustomerRoutingModule } from 'src/app/customer-modules/customer/customer-routing.module';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  menuItems: BehaviorSubject<CoreTypes.MenuHierarchy[]> = new BehaviorSubject<CoreTypes.MenuHierarchy[]>([]);

  constructor(
    private customerRoutingModule: CustomerRoutingModule
  ) { }

  getItemUrl(menuId: number, parentId?: number):any {
    const customerPath = this.customerRoutingModule.customerPaths(menuId);
    if (customerPath !== null) { return customerPath; }
    switch(menuId) {
      // case GearTypes.GearMenuHierarchyItem.Maps:
      //   return 'map';
      case GearTypes.GearMenuHierarchyItem.AlarmWithHeatMap:
        return 'maps/alarms';
      case GearTypes.GearMenuHierarchyItem.FacilityMap:
        return 'map';
      case GearTypes.GearMenuHierarchyItem.DeviceMap:
        return 'devices-map';
      case GearTypes.GearMenuHierarchyItem.Dashboards:
        return 'dashboard';
      case GearTypes.GearMenuHierarchyItem.ClientDashboards:
        return 'dashboards';
      case GearTypes.GearMenuHierarchyItem.AssetTracking:
        return 'asset-tracking';
      case GearTypes.GearMenuHierarchyItem.Tanks:
        return 'tanks';
      case GearTypes.GearMenuHierarchyItem.FacilityGraphicalViewPlans:
        return 'plan';
      case GearTypes.GearMenuHierarchyItem.Endpoints:
        return 'devices';
      // case GearTypes.GearMenuHierarchyItem.EndpointHistoryMenu:
      //   return 'endpoints-history';
      case GearTypes.GearMenuHierarchyItem.EndpointHistory:
        return 'endpoints-history/history';
      case GearTypes.GearMenuHierarchyItem.EndpointComparativeHistory:
        return 'endpoints-history/comparative';
      case GearTypes.GearMenuHierarchyItem.Incidents:
        return 'incident-map';
      case GearTypes.GearMenuHierarchyItem.IncidentManagement:
        return 'incident-management';
      default:
        if (parentId === GearTypes.GearMenuHierarchyItem.Maps) {
          return 'maps/custom/' + menuId;
        }
        if (parentId === GearTypes.GearMenuHierarchyItem.Reports) {
          return 'reports/' + menuId;
        }
    }
  }
}
